import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { useCurrentUser } from 'modules/utils';
import { memo, useCallback, useEffect, useMemo } from 'react';

import EmailToSupplierForm from '../../../../components/EmailToSupplierForm/EmailToSupplierForm';
import { getNewSupplierAttachments, getSupplierAttachments, isLoading } from '../../../../selectors/pageSelectors';
import { placeholderList } from './NetSuiteEmailToSupplier.constants';
import { NetSuiteEmailToSupplierProps } from './NetSuiteEmailToSupplier.types';

const NetSuiteEmailToSupplier = memo<NetSuiteEmailToSupplierProps>((props) => {
    const { data, vendorEmail, isEnabled, setData, setIsEnabled, setAttachments, removeAttachment, showErrors } = props;

    const attachments = useSelector(getSupplierAttachments);
    const newAttachments = useSelector(getNewSupplierAttachments);
    const isAttachmentsLoading = useSelector(isLoading);

    useEffect(() => {
        setAttachments(attachments);
    }, [attachments, setAttachments]);

    const validateToParam = useCallback((data: domain.EmailToSupplier | null) => {
        return data?.to.length === 0;
    }, []);

    const currentUser = useCurrentUser();

    const contacts = useMemo(() => {
        const contactList = [
            {
                firstName: currentUser.firstName,
                lastName: currentUser.lastName,
                emailAddress: currentUser.userEmail,
                includeInEmails: true,
            },
        ];

        if (vendorEmail) {
            contactList.push({
                firstName: '',
                lastName: '',
                emailAddress: vendorEmail,
                includeInEmails: true,
            });
        }

        return contactList;
    }, [currentUser, vendorEmail]);

    return (
        <EmailToSupplierForm
            data={data}
            onChangeData={setData}
            contacts={contacts}
            toValidatorFunction={validateToParam}
            isVisible={isEnabled}
            onVisibilityToggle={setIsEnabled}
            attachments={data?.attachments ?? []}
            attachmentsNew={newAttachments}
            isAttachmentsLoading={isAttachmentsLoading}
            onAttachRemove={removeAttachment}
            hasErrors={showErrors}
            integrationType={domain.IntegrationType.NetSuite}
            placeholderList={placeholderList}
        />
    );
});

export default NetSuiteEmailToSupplier;
